import React, { useCallback } from 'react';

import { Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { getUserL2Access } from 'Deer/helpers/getUserAccess';
import styled from 'styled-components';
import { Divider1 } from 'styles/common';

import { CheckedCheckboxIcon, UncheckedCheckboxIcon } from 'constants/icons';

import { Typography6, Typography13 } from 'uiToolkit/Typography';

const Container = styled.div`
  padding: 1.5rem;
`;

const PermissionRowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 1.5rem;
  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`;

const StyledCheckbox = withStyles({
  root: {
    padding: 0,
    marginRight: '1rem',
  },
})(Checkbox);

const PermissionRow = ({ id, title, checked, onToggle }) => (
  <PermissionRowContainer>
    <StyledCheckbox
      disableRipple
      checked={checked}
      onChange={() => onToggle(id)}
      checkedIcon={<CheckedCheckboxIcon size="fixed20px" />}
      icon={<UncheckedCheckboxIcon size="fixed20px" />}
    />
    <Typography13>{title}</Typography13>
  </PermissionRowContainer>
);

const CUSTOM_ROLE_PERMISSIONS = [
  {
    id: 'GOAL_INSIGHTS',
    title: 'Goal Insights',
    accessKey: 'hasGoalAccess',
  },
  {
    id: 'ONE_ON_ONE_INSIGHTS',
    title: '1:1 Insights',
    accessKey: 'hasOneOnOneAccess',
  },
  {
    id: 'REVIEW_INSIGHTS',
    title: 'Review Insights',
    accessKey: 'hasReviewAccess',
  },
  {
    id: 'ENGAGEMENT_INSIGHTS',
    title: 'Engagement Insights',
    accessKey: 'hasEngagementAccess',
  },
  {
    id: 'FEEDBACK_INSIGHTS',
    title: 'Feedback Insights',
    accessKey: 'hasFeedbackAccess',
  },

  {
    id: 'DISCIPLINARY_ACTION_INSIGHTS',
    title: 'Disciplinary Action Insights',
    accessKey: 'hasDisciplinaryActionsAccess',
  },
];

const DataAccessSection = ({ selectedPermissions, handlePermissionChange }) => {
  const onToggle = useCallback(
    (permissionId) => {
      handlePermissionChange(permissionId);
    },
    [handlePermissionChange]
  );

  const isChecked = useCallback((permissionId) => selectedPermissions.includes(permissionId), [selectedPermissions]);

  const userAccess = getUserL2Access();

  const filteredPermissions = CUSTOM_ROLE_PERMISSIONS.filter((permission) => userAccess[permission.accessKey]);

  return (
    <Container>
      <Typography6 weight={400}>The admins will have access to the following data</Typography6>
      {filteredPermissions.map(({ id, title }, index) => (
        <React.Fragment key={id}>
          <PermissionRow id={id} title={title} checked={isChecked(id)} onToggle={onToggle} />
          {index !== filteredPermissions.length - 1 && <Divider1 />}
        </React.Fragment>
      ))}
    </Container>
  );
};

export default DataAccessSection;
